<template>
  <div>
    <h4>Запись будет скрыта и отправлена на модерацию</h4>
    <textarea v-model="comment" class="form-control mt-2" placeholder="Комментарий" rows="3"/>
  </div>
</template>

<script>

import api from "@/api";

export default {
  props: ['data'],
  data() {
    return {
      comment: ''
    }
  },
  methods: {
    async updateRecord() {
      if (!this.comment) {
        return {success: false, message: 'Комментарий обязателен'};
      }
      const {data} = await api.post('/statistics/003/codes', {
        action: 'updateStatus',
        status_type: 'moderation',
        data: {comment: this.comment},
        drug_id: this.data.record?.drug_id,
      })
      return {success: data?.success ?? false};
    }
  }
}

</script>
